// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import { mergeClasses } from 'util/commons';
import './BottomField.scss';
import React from 'react';

interface Props {
  children?: React.ReactNode;
  className?: string;
}

export function BottomField({ children, className }: Props) {
  return (
    <div className={mergeClasses('bottom-field', className)}>{children}</div>
  );
}
